import React from "react";
import { Fade } from "react-reveal";
import styled from "styled-components";
import logo from "../images/logo.png";

const LText = ({ text, subtext }) => {
  return (
    <Container>
      <Fade left>
        <img src={logo} alt="mendes & Herrero" />
        <br />
        <h1>{text}</h1>
        <h2>{subtext}</h2>
      </Fade>
    </Container>
  );
};
export default LText;

const Container = styled.div`
  display: column;
  text-align: center;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding-top: 70px;
  img {
    width: 600px;
  }
  h1 {
    padding-top: 30px;
    font-family: "Jost", sans-serif;
    font-size: 40px;
    color: #ffffff;
  }
  h2 {
    margin: auto;
    padding-top: 8px;
    font-family: "Jost", sans-serif;
    font-size: 20px;
    color: #bbbbbb;
    width: 50%;
  }
  @media (max-width: 850px) {
    img {
      width: 100%;
    }
  }
`;
